<template>
  <div id="multiMenu">
    <div
      id="multiMenu"
      class="language-control-menu"
      style="cursor: pointer; "
      v-if="params.languageMenuActivate"
    >
      <div
        @click="setTypeLanguageMenu('spanish')"
        :style="{fontWeight: (multiLanguage === 'spanish') ? '600' : 'unset'}"
        style="margin-right: 5px;"
        v-if="getAvailableLang('spanish')"
      >ES</div>
      <div v-if="(getAvailableLang('spanish') && getAvailableLang('french')) || (getAvailableLang('spanish') && getAvailableLang('english'))">/</div>
      <div
        @click="setTypeLanguageMenu('english')"
        :style="{fontWeight: (multiLanguage === 'english') ? '600' : 'unset', marginRight: getAvailableLang('french') ? '5px':''}"
        style="margin-left: 5px;"
        v-if="getAvailableLang('english')"
      >EN</div>
      <div v-if="(getAvailableLang('english') && getAvailableLang('french') && getAvailableLang('spanish')) || (getAvailableLang('english') && getAvailableLang('french') && !getAvailableLang('spanish'))" >/</div>
      <div
        @click="setTypeLanguageMenu('french')"
        :style="{fontWeight: (multiLanguage === 'french') ? '600' : 'unset'}"
        style="margin-left: 5px;"
        v-if="getAvailableLang('french')"
      >FR</div>
    </div>
    <div class="columns is-mobile is-multiline is-centered">
      <div
        :id="'menu-' + index"
        :key="'menu-' + index"
        class="column is-12 mb-2"
        v-for="(item, index) in getShowMenu(data)"
      >
        <div
          :class="{ 'no-background': stateBackground(item) }"
          :style="{
            'background-image': `${gradient()} url('${getImage(item)}')`,
          }"
          @click="select(item)"
          class="btn-card-mobile mx-auto is-flex is-flex-direction-row is-justify-content-center is-align-items-center btn-menu-multiple"
        >
          <span class="title-text-menu">{{ getTitle(item) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { metrics } from '@/helpers/apis/metrics.js';
import globalTypes from '@/store/types/global';
export default {
  data () {
    return {
      data: []
    };
  },
  mounted () {
    console.log(this.multiLanguage);
    if (this.params.languageMenuActivate && this.params.availableLanguages && this.params.availableLanguages !== null) {
      const orderLangs = this.params.availableLanguages.split(',').sort((a, b) => {
        const order = { spanish: 1, english: 2, french: 3 };
        return (order[a] || 0) - (order[b] || 0);
      });
      if (this.multiLanguage !== orderLangs[0]) {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, this.multiLanguage);
      } else {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, orderLangs[0]);
      }
    }
    this.getMenus(this.vendor.id);
    if (this.params.bannerActiveMenuDigital === 1) {
      this.$store.commit('whiteLabel:setMenuIdBanner', 'Menu Multiple');
    }
  },
  computed: {
    getAvailableLang () {
      return (value) => {
        if (this.params.availableLanguages && this.params.availableLanguages !== null) {
          const arrayLangs = this.params.availableLanguages.split(',');
          if (arrayLangs.find(lang => lang === value)) {
            return true;
          }
          return false;
        }
        return true;
      };
    }
  },
  methods: {
    getShowMenu (items) {
      const data = [];
      const hour = this.$moment().format('YYYY-MM-DD HH:mm');
      const todayNumber = this.$moment().day();
      items.forEach(element => {
        if (element.programing) {
          const ini = this.$moment().format('YYYY-MM-DD') + ' ' + element.initPrograming;
          const fin = this.$moment().format('YYYY-MM-DD') + ' ' + element.finishPrograming;
          const horaActual = parseInt(this.$moment(hour).format('x'));
          const horaInicio = parseInt(this.$moment(ini).format('x'));
          const horaFin = parseInt(this.$moment(fin).format('x'));

          if (element.dayOfWeek && element.initPrograming && element.finishPrograming) {
            if ((horaActual >= horaInicio && horaActual <= horaFin) && element.dayOfWeek.includes(todayNumber)) {
              data.push(element);
            }
          } else if (element.initPrograming && element.finishPrograming) {
            if ((horaActual >= horaInicio && horaActual <= horaFin)) {
              data.push(element);
            }
          } else if (element.dayOfWeek) {
            if (element.dayOfWeek.includes(todayNumber)) {
              data.push(element);
            }
          }
        } else {
          data.push(element);
        }
      });
      return data.filter(item => {
        return (
          this.getImage(item) ||
          (this.getTitle(item) !== null && this.getTitle(item).trim() !== '')
        );
      });
    },
    setTypeLanguageMenu (type) {
      this.$store.commit(globalTypes.mutations.setMultiLanguage, type);
      this.sendMetric();
    },
    getImage (item) {
      if (this.params.languageMenuActivate) {
        if (this.multiLanguage === 'spanish') {
          return item.image;
        }
        if (
          this.multiLanguage === 'english' &&
            item.imageEnglish !== null
        ) {
          return item.imageEnglish;
        }
        if (
          this.multiLanguage === 'french' &&
            item.imageFrench !== null
        ) {
          return item.imageFrench;
        }
      } else {
        if (item.image != null) {
          return item.image;
        } else if (item.imageEnglish != null) {
          return item.imageEnglish;
        }
      }
    },
    getTitle (item) {
      if (this.params.languageMenuActivate) {
        if (this.multiLanguage === 'spanish') {
          return item.title;
        }
        if (
          this.multiLanguage === 'english' &&
            item.titleEnglish !== null
        ) {
          return item.titleEnglish;
        }
        if (
          this.multiLanguage === 'french' &&
            item.titleFrench !== null
        ) {
          return item.titleFrench;
        } else {
          return item.title;
        }
      } else {
        if (item.title != null) {
          return item.title;
        } else if (item.titleEnglish != null) {
          return item.titleEnglish;
        }
      }
    },
    stateBackground (item) {
      let result = false;
      if (this.multiLanguage === 'spanish' && item.image === null) {
        result = true;
      } else if (this.multiLanguage === 'english' && item.imageEnglish === null) {
        result = true;
      }
      return result;
    },
    getMenus (id) {
      this.$store
        .dispatch({
          type: 'whiteLabel:menusMenuDigital',
          data: { vendorId: id }
        })
        .then((response) => {
          this.data = response.data;
          this.data.forEach(element => {
            if (element.dayOfWeek != null) {
              const strDaysArray = element.dayOfWeek.split(',');
              element.dayOfWeek = strDaysArray.map(Number);
            }
          });
          this.sendMetric();
        })
        .catch((e) => {
          console.log('error:', e);
        });
    },
    select (item) {
      /* item.options[0].descriptionSubFooter */
      metrics('multimenu', this.multiLanguage, item.id);
      if (this.params.typeMenuDigital === 'advanced') {
        this.$emit('menuSelected', item.options);
        this.$emit('activeView', 2);
      } else {
        this.$emit('menuSelected', item.options);
        this.$emit('activeView', 61);
      }
    },
    sendMetric () {
      metrics('menu-lists', this.multiLanguage);
    }
  }
};
</script>
<style lang="scss">
#multiMenu {
  margin: 0 auto;
  .title-text-menu{
    text-align: center;
  }
  #menu-0 {
    padding-left: unset;
    padding-right: unset;
  }
  .menu {
    height: 144px;
    width: 100%;
    background-position: center center;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: 25px;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    .tittle {
      font-size: 26px;
      color: #ffffff;
      font-weight: 600;
      letter-spacing: 3px;
      text-align: center;
      text-transform: uppercase;
      margin-bottom: 20px;
    }
  }
  @media screen and (max-width: 425px) and (min-width: 50px) {
    .btn-card-mobile {
      max-width: 348px;
      height: 163px;
    }
  }
}
</style>
